import React from 'react';
import { UserIcon } from 'lucide-react';
export function Header() {
  return <header className="h-14 backdrop-blur border-b shrink-0 z-20 flex items-center justify-between px-6 bg-olympian-navy/80 border-olympian-border" data-id="element-94">
      <div className="flex items-center gap-3" data-id="element-95">
        <span className="text-lg font-bold tracking-wide text-theme" data-id="element-96">
          Opus Home Loans
        </span>
      </div>

      <div className="flex items-center gap-3" data-id="element-97">
        <div className="text-right hidden sm:block" data-id="element-98">
          <div className="text-sm font-medium text-theme leading-tight" data-id="element-99">
            Alex Mercer
          </div>
          <div className="text-[10px] text-olympian-textMuted" data-id="element-100">
            Senior Loan Officer
          </div>
        </div>
        <div className="w-8 h-8 rounded-full flex items-center justify-center border bg-olympian-surface border-olympian-border" data-id="element-101">
          <UserIcon className="w-4 h-4 text-olympian-textMuted" data-id="element-102" />
        </div>
      </div>
    </header>;
}